import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isValidEnrichedMeetingType } from '../../entities/EnrichedMeetingType';
import { BaseClient } from '../BaseClient';
export class EnrichedMeetingTypeClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createEnrichedMeetingTypeImpl", void 0);
    _defineProperty(this, "deleteEnrichedMeetingTypeImpl", void 0);
    _defineProperty(this, "queryEnrichedMeetingTypesImpl", void 0);
    _defineProperty(this, "getEnrichedMeetingTypeImpl", void 0);
    _defineProperty(this, "updateEnrichedMeetingTypeImpl", void 0);
  }
  async createEnrichedMeetingType(newEnrichedMeetingType) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        enrichedMeetingType
      } = await this.request(this.createEnrichedMeetingTypeImpl({
        enrichedMeetingType: newEnrichedMeetingType
      }), ...args);
      return this.convertToEntity(enrichedMeetingType);
    } catch (error) {
      this.logError('createEnrichedMeetingType', 'Failed to create enriched meeting type', {
        newEnrichedMeetingType
      }, error);
      throw error;
    }
  }
  async getEnrichedMeetingType(enrichedMeetingTypeId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        enrichedMeetingType
      } = await this.request(this.getEnrichedMeetingTypeImpl({
        enrichedMeetingTypeId
      }), ...args);
      return this.convertToEntity(enrichedMeetingType);
    } catch (error) {
      this.logError('getEnrichedMeetingType', 'Failed to get enriched meeting type', {
        enrichedMeetingTypeId
      }, error);
      throw error;
    }
  }
  async updateEnrichedMeetingType(enrichedMeetingTypeData) {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }
      const {
        enrichedMeetingType
      } = await this.request(this.updateEnrichedMeetingTypeImpl({
        enrichedMeetingType: enrichedMeetingTypeData,
        fieldMask: ['name', 'guidelines', 'meetingLinkProvider']
      }), ...args);
      return this.convertToEntity(enrichedMeetingType);
    } catch (error) {
      this.logError('updateEnrichedMeetingType', 'Failed to update enriched meeting type', {
        enrichedMeetingTypeData
      }, error);
      throw error;
    }
  }
  async deleteEnrichedMeetingType(enrichedMeetingTypeId) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      await this.request(this.deleteEnrichedMeetingTypeImpl({
        enrichedMeetingTypeId
      }), ...args);
    } catch (error) {
      this.logError('deleteEnrichedMeetingType', 'Failed to delete enriched meeting type', {
        enrichedMeetingTypeId
      }, error);
      throw error;
    }
  }
  async queryEnrichedMeetingTypes(query) {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }
      const {
        items,
        cursor,
        count,
        hasNext
      } = await this.request(this.queryEnrichedMeetingTypesImpl({
        query
      }), ...args);
      if (!items) {
        throw new Error('Received invalid enriched meeting types');
      }
      return {
        items: items.map(this.convertToEntity),
        cursor,
        count,
        hasNext: hasNext || false
      };
    } catch (error) {
      this.logError('queryEnrichedMeetingTypes', 'Failed to query enriched meeting types', {
        query
      }, error);
      throw error;
    }
  }
  convertToEntity(meetingType) {
    try {
      if (!meetingType) {
        throw new Error('Invalid meetingType');
      }
      if (!isValidEnrichedMeetingType(meetingType)) {
        throw new Error('Invalid meetingType data');
      }
      return meetingType;
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert action', {
        meetingType
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'EnrichedMeetingTypeClient';
  }
}
//# sourceMappingURL=EnrichedMeetingTypeClientBase.js.map